export const profile = {
  name: "Salma Laouy",
  role: "Développeuse Web Full Stack (Junior)",
  location: "Marrakech, Maroc",
  email: "salmalaouy133@gmail.com",

  github: "https://github.com/salmaly-ui",
  linkedin: "https://www.linkedin.com/in/salma-laouy-921991397 ",

  about:
    "Étudiante en informatique à l’ENS de Marrakech, passionnée par le développement web et la création d’applications utiles. J’aime concevoir des systèmes complets (frontend + backend) avec des technologies modernes et améliorer constamment mes compétences.",

  skills: [
    "HTML",
    "CSS",
    "JavaScript",
    "Bootstrap",
    "React",
    "TypeScript",
    "PHP",
    "MySQL",
    "MVC",
    "Git",
    "Java",
    "C",
    "C++",
    "C#",
    "Nodejs",
    "Chart.js",
    "DataTables"
  ],

  languages: [
    { name: "Arabe", level: "Maternelle" },
    { name: "Français", level: "Courant" },
    { name: "Anglais", level: "Intermédiaire" }
  ]
};
